import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const UserLevelModule = React.lazy(() => import("./UserLevelModule"));
const HomePage = React.lazy(() => import("./pages/HomePage/HomePage"));

export const UserLevelModuleRoutes: RouteObject = {
  path: ":clientId/user-home",
  element: <ModuleRoute El={UserLevelModule} moduleName="user-home" />,
  children: [
    {
      path: "",
      element: <PageRoute El={HomePage} />,
    },
  ],
};
